class BackInStock extends HTMLElement {
  constructor() {
    super();
    this.els();

    if (!this.dialogEl) {
      this.createDialogEl();
    } else {
      this.dialog = this.dialogEl;
    }

    requestAnimationFrame(() => {
      this.variantData = JSON.parse(
        document.querySelector(
          `[type="application/json"][data-json="product-variants"][data-json-product-id="${this.productId}"]`
        ).textContent
      );
      this.listeners();
    });

    this.isOpen = false;
    this.classList.remove('hide');
  }

  /* https://developers.klaviyo.com/en/docs/how_to_set_up_custom_back_in_stock */
  async klaviyoBackInStockSubscription(settings) {
    const klaviyoPayload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: settings.email,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + settings.variantId,
            },
          },
        },
      },
    };

    const endPoint =
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
      window.klaviyoCompanyID;
    const requestOptions = {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        revision: '2025-01-15',
      },
      body: JSON.stringify(klaviyoPayload),
      redirect: 'follow',
    };

    return fetch(endPoint, requestOptions);
  }

  /* progressively enhanced dialog el, unsupported browsers will still work without it */
  createDialogEl() {
    if (!window.hasDialogSupport) {
      this.listeners();
      return;
    }

    /* create new Dialog modal */

    this.dialog = document.createElement('dialog');
    this.dialog.dataset.backInStockDialog = '';
    this.dialog.classList.add('back-in-stock__dialog');

    this.dialog.innerHTML = this.modalEl.innerHTML;
    this.modalEl.innerHTML = '';
    this.modalEl.appendChild(this.dialog);
  }

  els() {
    this.closeEl = this.querySelector('[data-back-in-stock-close]');
    this.detailsEl = this.querySelector('[data-back-in-stock]');
    this.toggleEls = document.querySelectorAll('[data-back-in-stock-toggle]');
    this.modalEl = this.querySelector('[data-back-in-stock-modal]');
    this.dialogEl = this.querySelector('[data-back-in-stock-dialog]');
    this.formEl = this.querySelector('[data-back-in-stock-form]');
    this.productId = this.dataset.productId;
  }

  listeners() {
    if (this.closeEl) {
      this.closeEl.addEventListener('click', (e) => {
        this.close();
      });
    }

    /* Close dialog element on backdrop and close button clicks */
    this.dialog.addEventListener('click', (e) => {
      if (
        e.target.closest('[data-back-in-stock-modal-content]') &&
        !e.target.closest('[data-back-in-stock-close]')
      )
        return;
      this.close();
    });

    this.dialog.addEventListener('close', (e) => {
      this.close();
    });

    if (this.toggleEls) {
      for (var i = 0, len = this.toggleEls.length; i < len; i++) {
        this.toggleEls[i].addEventListener('click', (e) => {
          e.preventDefault();
          const optValue = e.currentTarget.dataset.optionValue;
          const variant = this.variantData.find((v) => {
            return v[this.uomOptionIndex] === this.uom && v.options.indexOf(optValue) > 0;
          });

          if (variant) {
            document.querySelector('input#variantId').value = variant.id;
          } else {
            return;
          }

          this.isOpen = !this.isOpen;

          if (this.isOpen) {
            this.open();
          } else {
            this.close();
          }
        });
      }
    }

    if (this.formEl) {
      this.handleBackInStock();
    }
  }

  close() {
    document.documentElement.classList.remove('back-in-stock-modal--active');

    setTimeout(() => {
      this.detailsEl.removeAttribute('open');

      if (this.dialog) {
        this.dialog.close();
      } else {
        window.menuToggling = false;
        window.removeTrapFocus();
      }

      this.isOpen = false;
    }, 300);
  }

  handleBackInStock() {
    const backInStockForm = document.querySelector('[data-back-in-stock-form]');
    if (!backInStockForm) return;

    const emailInput = backInStockForm.querySelector('input[type=email]');
    const variantIdInput = backInStockForm.querySelector('input#variantId');
    const submitBtn = backInStockForm.querySelector('.back-in-stock__submit');

    backInStockForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!emailInput.checkValidity()) {
        backInStockForm.classList.add('error');
        return;
      }
      if (!variantIdInput.checkValidity()) {
        backInStockForm.classList.add('error');
        return;
      }

      this.klaviyoBackInStockSubscription({
        email: emailInput.value,
        variantId: variantIdInput.value,
      })
        .then((response) => {
          if (response.ok) {
            backInStockForm.classList.remove('error');
            backInStockForm.classList.add('success');
            submitBtn.classList.add('js-hide');
          } else {
            backInStockForm.classList.add('error');
          }
        })
        .catch((error) => {
          backInStockForm.classList.add('error');
        });

      return false;
    });
  }

  open() {
    /* this.scrollLock(); */
    this.detailsEl.setAttribute('open', true);

    requestAnimationFrame(() => {
      if (this.dialog) {
        this.dialog.showModal();
        requestAnimationFrame(() => {
          document.documentElement.classList.add('back-in-stock-modal--active');
        });
      } else {
        window.menuToggling = true;
        document.documentElement.classList.add('back-in-stock-modal--active');
        window.trapFocus(this.modalEl);
      }

      this.isOpen = true;
    });
  }

  scrollLock() {
    document.body.style.left = 0;
    document.body.style.right = 'var(--scrollbar-width), 0';
    document.body.style.top = `-${window.pageY}px`;
    document.body.style.position = 'fixed';
  }

  scrollUnlock() {
    document.body.style.position = null;
    document.body.style.left = null;
    document.body.style.right = null;
    document.body.style.top = null;
    window.scrollTo(0, window.pageY);
  }
}

customElements.define('back-in-stock', BackInStock);
